import fs from "node:fs";
import path from "node:path";
import { downloadImage, getFilenameFromUrl, success } from "@iflyrpa/share";
import FormData from "form-data";
import type { Toutiao } from "../../types";
import { Http } from "../../utils/http";
import type { PublishAction } from ".";

export const mockAction: PublishAction = async (task, params) => {
    const tmpCachePath = task.getTmpPath();

    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            origin: "https://mp.toutiao.com",
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
        },
    });

    // 0. 校验登录
    const userInfoRes = await http.api<{ code: number }>({
        method: "get",
        url: "https://mp.toutiao.com/mp/agw/creator_center/user_info",
    });

    if (userInfoRes.code !== 0) {
        return { code: 0, message: "登录失效", data: userInfoRes };
    }

    // 1. 上传图片
    const imageList: string[] = [];
    if (params.banners && params.banners.length > 0) {
        const images = await Promise.all(
            params.banners.map((url) => {
                const fileName = getFilenameFromUrl(url);
                return downloadImage(url, path.join(tmpCachePath, fileName));
            }),
        );

        const res = await Promise.all(
            images.map(async (it) => {
                const formData = new FormData();
                formData.append("image", fs.createReadStream(it));

                const response = await http.api<{ data: Toutiao.ImageData }>({
                    method: "post",
                    url: "https://mp.toutiao.com/spice/image?upload_source=20020003&aid=1231&device_platform=web",
                    data: formData,
                });

                return response.data;
            }),
        );

        imageList.push(...res.map((it) => it.image_uri));
    }

    // 2. 构造发布数据
    const extra = {
        add_music_to_article_flag: "0", // 开启配乐
        claim_exclusive: "0", // 原创&首发声明
        tuwen_wtt_trans_flag: "0",
        info_source: JSON.stringify({
            source_type: 5,
            source_author_uid: "",
            time_format: "",
            position: {},
        }),
        ugc_position: JSON.stringify({
            address: "",
            position: "合肥市",
            city: "合肥市",
            longitude: 117.227289,
            latitude: 31.82057,
            poi_type_code: "190104",
            poi_id: "22535659123306003",
        }),
    };

    const syncData = {
        content: params.content, // 正文,
        image_list: imageList, // 图片列表
        is_fans_article: 2,
        pre_upload: 1,
        welfare_card: "",
        extra: JSON.stringify(extra),
    };

    // biome-ignore lint/suspicious/noExplicitAny: false positive
    const res = await http.api<any>({
        method: "post",
        url: "https://mp.toutiao.com/mp/agw/article/wtt",
        data: syncData,
    });

    return success(res.data);
};
